// src/components/LocationForm.js
import React, { useRef, memo } from 'react'; // Import memo
import { TextField, Typography, Box, Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
// Import refs if needed for focus logic

// Use React.memo to prevent re-renders if props don't change
const LocationForm = memo(function LocationForm({
  formData,
  handleInputChange,
  validationErrors,
  actionLoading,
  isEdit, // Pass isEdit if needed for conditional readOnly
  // Pass refs if you are handling focus logic here
  storeNameRef,
  csidRef,
  fullNameRef,
  addressLine1Ref,
  addressLine2Ref,
  addressLine3Ref,
  cityRef,
  stateRef,
  zipCodeRef,
  emailRef,
  gstinRef,
  gstRef,
  companyPANRef,
  phoneRef,
}) {

  console.log("LocationForm rendering"); // Add console log to see how often this renders

  return (
    <Grid container spacing={2}> {/* Grid for dialog content layout */}
      <Grid item xs={12} sm={6}>
        <TextField
          autoFocus
          margin="dense"
          name="StoreName"
          label="Location Name"
          type="text"
          fullWidth
          value={formData.StoreName}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={storeNameRef}
          error={Boolean(validationErrors.StoreName)}
          helperText={validationErrors.StoreName}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="CSID"
          label="Location ID"
          type="text"
          fullWidth
          value={formData.CSID}
          onChange={handleInputChange}
          disabled={actionLoading || isEdit} // Disable CSID in edit mode
          inputRef={csidRef}
          InputProps={{
            readOnly: isEdit, // Make it read-only in Edit mode
          }}
          error={Boolean(validationErrors.CSID)}
          helperText={validationErrors.CSID}
        />
      </Grid>
      {/* Nested StoreAddress Fields */}
      <Grid item xs={12}>
        <Typography variant="subtitle1" sx={{ mt: 1, mb: 0.5 }}>Location Address:</Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          margin="dense"
          name="StoreAddress.FullName"
          label="Address Full Name"
          type="text"
          fullWidth
          value={formData.StoreAddress.FullName}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={fullNameRef}
          error={Boolean(validationErrors['StoreAddress.FullName'])}
          helperText={validationErrors['StoreAddress.FullName']}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          margin="dense"
          name="StoreAddress.AddressLine1"
          label="Address Line 1"
          type="text"
          fullWidth
          value={formData.StoreAddress.AddressLine1}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={addressLine1Ref}
          error={Boolean(validationErrors['StoreAddress.AddressLine1'])}
          helperText={validationErrors['StoreAddress.AddressLine1']}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          margin="dense"
          name="StoreAddress.AddressLine2"
          label="Address Line 2"
          type="text"
          fullWidth
          value={formData.StoreAddress.AddressLine2}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={addressLine2Ref}
          error={Boolean(validationErrors['StoreAddress.AddressLine2'])}
          helperText={validationErrors['StoreAddress.AddressLine2']}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          margin="dense"
          name="StoreAddress.AddressLine3"
          label="Address Line 3"
          type="text"
          fullWidth
          value={formData.StoreAddress.AddressLine3}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={addressLine3Ref}
          error={Boolean(validationErrors['StoreAddress.AddressLine3'])}
          helperText={validationErrors['StoreAddress.AddressLine3']}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="StoreAddress.CityName"
          label="City"
          type="text"
          fullWidth
          value={formData.StoreAddress.CityName}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={cityRef}
          error={Boolean(validationErrors['StoreAddress.CityName'])}
          helperText={validationErrors['StoreAddress.CityName']}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="StoreAddress.StateName"
          label="State"
          type="text"
          fullWidth
          value={formData.StoreAddress.StateName}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={stateRef}
          error={Boolean(validationErrors['StoreAddress.StateName'])}
          helperText={validationErrors['StoreAddress.StateName']}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="StoreAddress.ZipCode"
          label="Zip Code"
          type="text"
          fullWidth
          value={formData.StoreAddress.ZipCode}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={zipCodeRef}
          error={Boolean(validationErrors['StoreAddress.ZipCode'])}
          helperText={validationErrors['StoreAddress.ZipCode']}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          margin="dense"
          name="StoreManagerEmail"
          label="Store Manager Email"
          type="email"
          fullWidth
          value={formData.StoreManagerEmail}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={emailRef}
          error={Boolean(validationErrors.StoreManagerEmail)}
          helperText={validationErrors.StoreManagerEmail}
        />
      </Grid>
      {/* <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="GSTIN"
          label="GSTIN"
          type="text"
          fullWidth
          value={formData.GSTIN}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={gstinRef}
          error={Boolean(validationErrors.GSTIN)}
          helperText={validationErrors.GSTIN}
        />
      </Grid> */}
      {/* <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="GST"
          label="GST"
          type="text"
          fullWidth
          value={formData.GST}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={gstRef}
          error={Boolean(validationErrors.GST)}
          helperText={validationErrors.GST}
        />
      </Grid> */}
      {/* <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="CompanyPAN"
          label="Company PAN"
          type="text"
          fullWidth
          value={formData.CompanyPAN}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={companyPANRef}
          error={Boolean(validationErrors.CompanyPAN)}
          helperText={validationErrors.CompanyPAN}
        />
      </Grid> */}
      <Grid item xs={12} sm={6}>
        <TextField
          margin="dense"
          name="StorePhoneNumber"
          label="Store Phone Number"
          type="tel"
          fullWidth
          value={formData.StorePhoneNumber}
          onChange={handleInputChange}
          disabled={actionLoading}
          inputRef={phoneRef}
          error={Boolean(validationErrors.StorePhoneNumber)}
          helperText={validationErrors.StorePhoneNumber}
        />
      </Grid>
    </Grid>
  );
});

export default LocationForm;